import React, { useCallback, useEffect, useState } from 'react'
import { Form, Input, Row, Table } from 'antd'
import { useRecoilState } from 'recoil'
import { userState } from '../../store/user'
import productApi from '../../api/product.api'
import styles from '../../styles/sales.module.scss'

const productColumns = [
  {
    title: '상품번호',
    // width: 65,
    dataIndex: 'productId',
    key: 'productId',
    ellipsis: true,
    // fixed: 'left',
    sorter: () => {},
  },
  {
    title: '카테고리',
    // width: 80,
    dataIndex: 'categoryName',
    key: 'categoryName',
    ellipsis: true,
    render: (value) => {
      if (value === '') {
        return <span>-</span>
      } else {
        return value
      }
    },
  },
  {
    title: '브랜드명',
    // width: 130,
    dataIndex: 'brandName',
    key: 'brandName',
    ellipsis: true,
  },
  {
    title: '상품명',
    // width: 150,
    dataIndex: 'productName',
    key: 'productName',
    ellipsis: true,
  },
]

const ProductSearchComponent = ({
  searchOptions,
  handleChange,
  handleProductSearch,
  handleProductRowEvent,
  tableOnChange,
  orderType,
  orderBy,
  orderInfo,
  setOrderInfo,
  selectedProductRows,
  setSelectedProductRows,
  selectedProductRowKeys,
  setSelectedProductRowKeys,
}) => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)

  const [productList, setProductList] = useState([])

  const productRowSelection = {
    type: 'radio',
    selectedRowKeys: selectedProductRowKeys,
    onSelect: (record, selected) => {
      // 옵션 선택값 초기화
      if (selected) {
        setSelectedProductRowKeys([record.productId])
        setSelectedProductRows([record])
      } else {
        setSelectedProductRowKeys([])
        setSelectedProductRows([])
        setOrderInfo({
          totalPrice: 0,
          ...orderInfo,
        })
      }
    },
  }

  useEffect(() => {
    if (user?.id) {
      readProductList()
    }
  }, [user, orderType, orderBy, searchOptions])
  /**
   * 상품 검색 api 호출
   */
  const readProductList = useCallback(
    async (type = '', productName) => {
      try {
        let param
        if (type === 'custom') {
          param = {
            productId: null,
            productMakerName: '',
            productName: productName,
            brandName: searchOptions.brandName,
            orderType: orderType,
            orderBy: orderBy,
          }
        } else {
          param = {
            productId: null,
            productMakerName: '',
            productName: searchOptions.productName,
            brandName: searchOptions.brandName,
            orderType: orderType,
            orderBy: orderBy,
          }
        }
        const res = await productApi.readProductListAll(param, user.id)
        if (res.data.code === 200) {
          setProductList(res.data.result)
        } else {
          alert('상품 검색에 실패하였습니다. 다시 시도해주시길 바랍니다.')
        }
      } catch (error) {
        console.log('readProduct search error', error)
        alert(error)
      }
    },
    [user, orderType, orderBy, searchOptions],
  )

  return (
    <div className={`${styles['order-component-each-detail']}`}>
      <h4 className={`${styles['order-each-detail-title']}`}>상품 검색</h4>
      <Row
        style={{
          width: '100%',
          justifyContent: 'space-between',
          rowGap: '8px',
        }}
      >
        <Form.Item className={`${styles['center-label']}`} labelAlign="left">
          <Input.Search
            name="productName"
            value={searchOptions.productName}
            onChange={handleChange}
            placeholder={`상품명`}
            onSearch={handleProductSearch}
          />
        </Form.Item>
        <Form.Item className={`${styles['center-label']}`} labelAlign="left">
          <Input.Search
            name="brandName"
            value={searchOptions.brandName}
            onChange={handleChange}
            placeholder={`브랜드명`}
            onSearch={handleProductSearch}
          />
        </Form.Item>
      </Row>

      <Table
        className={`${styles['order-create-product-list-table']}`}
        rowSelection={productRowSelection}
        columns={productColumns}
        dataSource={productList}
        loading={isLoading}
        bordered
        size="middle"
        rowKey="productId"
        rowClassName="coupon-table-row"
        scroll={{ y: 'calc(191px - 48px)' }}
        onRow={handleProductRowEvent}
        onChange={tableOnChange}
        tableLayout="auto"
        pagination={false}
      />
    </div>
  )
}
export default ProductSearchComponent
